/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

export const PARSED_FIELD_FRAGMENT = gql`
  fragment ParsedField on ParsedField {
    id
    value
    error
  }
`
